import Typography from '@mui/material/Typography'
import Slider from '@mui/material/Slider'
import { FormSectionProps } from '../../interfaces/form'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import { useForm } from 'react-final-form'

import FormWizard from '../wizard'

const overrideSliderStyle = {
  '& .MuiSlider-thumb': {
    width: 30,
    height: 30,
    '&:hover': {
      boxShadow: 'none',
    },
    '&.Mui-active': {
      boxShadow: 'none',
    },
  },
  '& .MuiSlider-valueLabel': {
    background: 'none',
    color: 'primary.main',
    fontSize: 24,
    marginBottom: 16,
  },
}

const MonthlyExpenses = ({ validate }: FormSectionProps) => {
  const form = useForm()

  const marks = [
    {
      value: 0,
      label: <strong>£ 0</strong>,
    },
    {
      value: 10000,
      label: <strong>£ 10000</strong>,
    },
  ]

  return (
    <Container maxWidth="md">
      <Box sx={{ mt: 7, mb: 12, display: 'flex' }} flexDirection="column">
        <FormWizard.Page validate={validate}>
          <Typography variant="h3" sx={{ mb: 4 }}>
            Other monthly expenses
          </Typography>
          <Typography variant="h6" sx={{ mb: 4, fontWeight: 'normal' }}>
            Think about anything else your household spends money on every
            month, like travel, food, utility bills and leisure – but{' '}
            <strong>don’t include your rent or mortgage payments</strong>.
          </Typography>
          <Typography variant="h6" sx={{ mb: 4, fontWeight: 'normal' }}>
            We've estimated this for you. You can use the slider to change the
            amount.
          </Typography>
          <Slider
            defaultValue={form.getState().values?.otherMonthlyExpenses}
            step={50}
            min={0}
            max={10000}
            marks={marks}
            onChange={(e, value) => {
              form.change('otherMonthlyExpenses', value)
            }}
            valueLabelDisplay="on"
            sx={{ ...overrideSliderStyle, mt: 8 }}
          />
        </FormWizard.Page>
      </Box>
    </Container>
  )
}

export default MonthlyExpenses
